import styled from "styled-components";
import { device } from "../../../style/util/media-query";
import { Paragraph } from "../../general/Paragraph/Paragraph";
import Divider from "../../general/Divider/Divider";
import { Icon } from "../../general/Icon/Icon";
import { size } from "../../../style/util/size";

export const StyledInfoContent = styled.div`
  text-align: center;

  @media ${device.desktop} {
    padding: 2rem 20%;
  }
`;

export const StyledIcon = styled(Icon)`

  display: none;
  position: relative;
  margin: 0 auto;
  color: ${({ theme }) => theme.colors.magenta};

  @media ${device.desktop} {
    display: block;
    ${size("3.6rem")};
  }

  @media ${device.desktopL} {
    ${size("5rem")};
  }
`;

export const StyledDescription = styled(Paragraph)`
  margin: 5.2rem 1rem;

  span {
    display: block;
    margin: 1.2em 0;
  }

  @media ${device.desktop} {
    margin: 0 2.5rem;
  }
`;

export const StyledDivider = styled(Divider)`
  width: 100%;
  margin: 1rem 0;

  @media ${device.desktop} {
    margin: 1.3rem 0 0;
  }
`;
